module.exports = __webpack_public_path__ + "img/62.fef31c8c.jpg";